export enum VisibleElementsAmount {
  LESS = 6,
  MORE = 8
}

export const VIEW_ALL_POPOVER = 'VIEW_ALL_POPOVER'
export const GO_TO_PREVIOUS_PAGE = 'GO_TO_PREVIOUS_PAGE'
export const GO_TO_NEXT_PAGE = 'GO_TO_NEXT_PAGE'
